// removed by extract-text-webpack-plugin
module.exports = {"vpSortOrderContainer":"vpSortOrderContainer___3YVAE","vpSortDisabled":"vpSortDisabled___1qwRj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignEdit/ElementSortButtons.module.less
// module id = 3555
// module chunks = 29